import { Spinner } from "@blueprintjs/core"
import StatusIcon from "components/Atoms/StatusIcon"
import CustomReactTable from "components/Templates/CustomReactTable"
import dayjs from "dayjs"
import { useReconciliationSummaryFundFlowQuery } from "generated/graphql"
import { useFundFlow } from "graphql/fund-flow/fund-flow.hooks"
import React from "react"
import { useSearchParams } from "react-router-dom"
import { inr } from "utils/formatters.utils"

const FundFlowList = () => {
  const [params] = useSearchParams()
  const date = params.get("date") || dayjs().format("YYYY-MM-DD")
  const { data, loading } = useReconciliationSummaryFundFlowQuery({
    variables: {
      filter: {
        date,
      },
    },
  })

  const COLUMNS = [
    {
      Header: "DC Name",
      accessor: "distributionCentre_Name",
      Cell({ value }) {
        return (
          <div className="px-3">
            <div>{value}</div>
          </div>
        )
      },
    },
    {
      Header: "Opening Balance",
      accessor: "openingBalance",
      Cell({ value }) {
        return inr(value)
      },
    },
    {
      Header: "Net Sale",
      accessor: "netSale",
      Cell({ value }) {
        return inr(value)
      },
    },
    {
      Header: "Collection",
      accessor: "collection",
      Cell({ value }) {
        return inr(value)
      },
    },
    {
      Header: "Deposit",
      accessor: "deposit",
      Cell({ value }) {
        return inr(value)
      },
    },
    {
      Header: "Closing Balance",
      accessor: "closingBalance",
      Cell({ value }) {
        return inr(value)
      },
    },
    {
      Header: "Status",
      accessor: "reconciliationStatus",
      Cell({ value }) {
        return (
          <StatusIcon
            values={{
              CON: { intent: "success", text: "Confirm" },
              FAL: { intent: "danger", text: "Reject" },
              PEN: { intent: "warning", text: "Pending" },
            }}
            condition={value}
          />
        )
      },
    },
  ]

  const SubRowAsync = row => {
    const { data, loading } = useFundFlow({
      distributionCentreId: row?.row?.distributionCentreId,
      date,
    })
    if (loading || !data?.allDcCollectionLogs?.length) return <Spinner />

    const obj = data.allDcCollectionLogs[0]

    const rows = [
      [
        "Cash In Hand",
        inr(obj.cashOpening),
        "-", //inr(obj.cashNetSale),
        inr(obj.cashCollection),
        inr(obj.cashDeposit),
        inr(obj.cashClosing),
        null,
      ],
      [
        "Credit Sale",
        inr(obj.creditSaleOpening),
        "-", //inr(obj.creditSaleNetSale),
        "-",
        "-",
        inr(obj.creditSaleClosing),
        null,
      ],
      [
        "Others",
        "-",
        "-", //inr(obj.othersNetSale),
        inr(obj.othersCollection),
        inr(obj.othersCollection),
        "-",
        null,
      ],
      [
        "Cheque",
        inr(obj.chequeOpening),
        "-", //inr(obj.chequeNetSale),
        inr(obj.chequeCollection),
        inr(obj.chequeDeposit),
        inr(obj.chequeClosing),
        null,
      ],
    ]
    return (
      <div className="rt-table pl-[35px] bg-yellow-100" role="grid">
        <div className="rt-tbody">
          {rows.map((row, rowId) => {
            return (
              <div key={rowId} className="rt-tr" role="row">
                {row.map((cell, cellId) => {
                  return (
                    <div key={cellId} className="rt-td" role={"gridcell"}>
                      {cell}
                    </div>
                  )
                })}
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  return (
    <CustomReactTable
      pageSize={
        data?.reconciliationSummaryFundFlow?.length > 20
          ? data?.reconciliationSummaryFundFlow?.length
          : 20
      }
      loading={loading}
      loadingText="Fetching data"
      data={data?.reconciliationSummaryFundFlow ?? []}
      columns={COLUMNS}
      SubComponent={row => <SubRowAsync row={row.original} />}
    />
  )
}

export default FundFlowList
